import { Button, ButtonProps } from 'antd'

import Can from 'component/can'
import { FEATURE } from 'constants/feature'

type ProtectedButtonProps = ButtonProps & {
  feature: FEATURE
  /** When true, requires CRUD rights instead of just view. */
  requireCRUD?: boolean
}

const ProtectedButton = ({ feature, requireCRUD, ...rest }: ProtectedButtonProps) => (
  <Can feature={feature} action={requireCRUD ? 'crud' : 'view'}>
    <Button {...rest} />
  </Can>
)

export default ProtectedButton
